import { ArrowLeft, ArrowRight } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../../atoms/button/button';

enum Direction {
  NEXT = 'next',
  PREVIOUS = 'previous',
}

function PageArrow({
  direction,
  disabled,
  onClick,
}: {
  readonly direction: Direction;
  readonly disabled: boolean;
  readonly onClick: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Button
      appearance="secondary"
      aria-label={t(`ui-components.table.pagination.${direction}Page`)}
      className="h-8 w-8"
      disabled={disabled}
      onClick={onClick}
      size="sm"
    >
      {direction === Direction.NEXT && <ArrowRight aria-hidden="true" className="text-typography-light" size={16} />}
      {direction === Direction.PREVIOUS && <ArrowLeft aria-hidden="true" className="text-typography-light" size={16} />}
    </Button>
  );
}

export { Direction, PageArrow };
